import React, {useEffect, useState} from "react";
import {CmDownload, PageGridPlacement as CmPageGridPlacement} from "../../../../packages/graphql-layer/src";
import {
    SETTING_QUICK_ACCESS_BUTTON_CSS_CLASS,
    SETTING_QUICK_ACCESS_BUTTON_TARGET,
    SETTING_QUICK_ACCESS_BUTTON_TEXT
} from "../../../pages/config/settings";
import Link from "next/link";
import Button from "@mui/material/Button";
import {Typography} from "@mui/material";
import {useQuery} from "@apollo/client";
import {
    GetCmDownloadByIdDocument
} from "../../../../packages/graphql-layer/src/queries/__generated__/GetCMDownloadById";
import {generateDownloadUrl, getIdFromHref} from "../../../utility/navigationUtil";
import {buttonStyle} from "../../../common/constants/buttonStyle";

export interface Props {
    page: any,
    fullWidth: boolean,
    buttonStyle?: React.CSSProperties
}

export const BUTTON_DEFAULT_COLOR = 'bgGreen';

export const buttonClasses: any = {
    bgGreen: buttonStyle.green,
    bgBlue: buttonStyle.blue,
    bgYellow: buttonStyle.yellow,
}

const QuickAccessButton = (props: Props) => {
    const button = props.page?.grid.placements.find((p: CmPageGridPlacement) => p.name === 'header')?.items[1];
    const buttonSettings = props.page?.quickAccessButton;
    const buttonCustomStyle = buttonClasses[buttonSettings?.[SETTING_QUICK_ACCESS_BUTTON_CSS_CLASS]] || buttonClasses[BUTTON_DEFAULT_COLOR];

    const [cmDownloadTarget, setCmDownloadTarget] = useState<CmDownload | null>(null);

    const downloadItemId = buttonSettings ? getIdFromHref(buttonSettings[SETTING_QUICK_ACCESS_BUTTON_TARGET]) : undefined
    useQuery(GetCmDownloadByIdDocument, {
        variables: {contentId: downloadItemId},
        onError: (err) => {
            console.log("Can't load collection: ", err);
        },
        onCompleted: (data) => {
            if (!data.content.content) {
                console.error("Can't load download:")
                return
            }
            setCmDownloadTarget(data.content.content)
        },
        fetchPolicy: 'network-only',
        skip: downloadItemId === null || downloadItemId === undefined || downloadItemId === '',
    });

    const buttonStyle: any = {
        ...props.buttonStyle,
        ...buttonCustomStyle,
        ':hover': {
            ...buttonCustomStyle[':hover'],
            transition: 'background-color 0.25s linear',
        }
    };

    useEffect(() => {
        if (!downloadItemId) {
            setCmDownloadTarget(null)
        }
    }, [downloadItemId])

    return (button && buttonSettings[SETTING_QUICK_ACCESS_BUTTON_TARGET]
            ? <Link data-cypress={'quickAccessLink'} id={"quick-access"}
                    style={{width: props.fullWidth ? '100%' : 'unset'}}
                    href={cmDownloadTarget ? generateDownloadUrl(
                        cmDownloadTarget.id ?? '',
                        cmDownloadTarget.title ?? ''
                    ) : buttonSettings[SETTING_QUICK_ACCESS_BUTTON_TARGET]}
                    target={cmDownloadTarget ? "_blank" : undefined}
                    prefetch={false}>
                <Button variant="contained"
                        fullWidth={props.fullWidth}
                        sx={buttonStyle}>
                    <Typography variant='ctaButton' sx={{lineHeight: "16px", marginY: "5px"}}>
                        {buttonSettings[SETTING_QUICK_ACCESS_BUTTON_TEXT]}
                    </Typography>
                </Button>
            </Link>
            : null
    );
}
export default React.memo(QuickAccessButton);
